import {Column, Table, AutoSizer} from 'react-virtualized';
import { Button, LinearProgress } from "@mui/material"
import { store } from '../../../stores/Store';
import { Icons } from '../../../misc/Icons';
import { observer } from 'mobx-react-lite';
import { DisplayValue } from '../../..';
import { Link } from 'react-router-dom';
import { format, formatDistance, isValid } from 'date-fns';
import InlineMenu from '../../../misc/InlineMenu';
import Field from '../../form/fields/Field';
import React from 'react';
import { UTCDate } from '@date-fns/utc';
import { ColumnHeaderAccount, ColumnHeaderStatus } from './AutomationLogTableHeaders';


export default observer(function ReportTable () {

    const { loadingLog, getFilteredLog, statusColor } = store.AutomationStore

    const rowHeight = 40
    const minWidth = 1070

    return (
        <>
            {loadingLog ? (
                <small style={{marginBottom: "5px"}}>Loading Automation log</small>
            ) : (
                <small style={{marginBottom: "5px"}}>{getFilteredLog?.length} Automations</small>
            )}
        
            <div className={`rv-table-wrapper rv-table-md`} style={{minHeight: "400px"}}>
                

                <AutoSizer>
                    {({height, width}) => (
                        <Table
                            width={width < minWidth ? minWidth : width}
                            height={height}
                            headerHeight={rowHeight}
                            rowHeight={rowHeight}
                            rowCount={getFilteredLog.length}
                            rowGetter={({index}) => getFilteredLog[index]}
                        >
                            <Column
                                width={130}
                                dataKey=""
                                headerRenderer={() => <DateColumnHeader />}
                                cellRenderer={(data) => (
                                    <span>{format(new Date(data.rowData.runAt), "yyyy-MM-dd hh:mm")}</span>
                                )} />

                            <Column
                                width={70}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="Run time" />}
                                cellRenderer={(data) => {
                                    const { runAt, stoppedAt, status } = data.rowData
                                    var secondsElapsed = null
                                    if (["INSTANTIATED", "RUNNING"].includes(status)) {
                                        secondsElapsed = (new Date().getTime() / 1000) - (new Date(runAt).getTime() / 1000)
                                    } else if (stoppedAt) {
                                        secondsElapsed = (new Date(stoppedAt).getTime() / 1000) - (new Date(runAt).getTime() / 1000)
                                    }

                                    if (typeof secondsElapsed !== "number") return <span className="font-grey">-</span>
                                    return (
                                        <span>
                                            {Math.floor(secondsElapsed / 60)}m  {Math.floor(secondsElapsed) % 60}s
                                        </span>
                                    )
                                }} />

                            <Column
                                width={50}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="Progress" />}
                                cellRenderer={(data) => {
                                    const { currentPageIndex, finalPageIndex } = data.rowData
                                    var percentComplete = currentPageIndex && finalPageIndex ? ((currentPageIndex + 1) / finalPageIndex) * 100 : null
                                    return (
                                        <span className={percentComplete === 100 ? "" : "font-grey"}>
                                            {Math.trunc(percentComplete)}%
                                        </span>
                                    )
                                }} />

                            <Column
                                width={80}
                                dataKey=""
                                headerRenderer={() => <ColumnHeaderStatus label="Status" />}
                                cellRenderer={(data) => {
                                    var color = statusColor(data.rowData.status)
                                    var status = DisplayValue("automation_status", data.rowData.status)
                                    return (
                                        <span style={{color: color}}><b>{status}</b></span>
                                    )
                                }} />

                            <Column
                                width={200}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="Automation" />}
                                cellRenderer={(data) => (
                                    <Link onClick={() => store.ToolStore.setOpen(false)} className="link" to={`/app/main/${data.rowData.case.uid}/${data.rowData.application.uid}`}>
                                        {data.rowData.label}
                                    </Link>
                                )} />

                            {store.AppStore.checkJwtRole("sysuser") ? (
                                <Column
                                    width={100}
                                    dataKey=""
                                    headerRenderer={() => <ColumnHeaderAccount label="Account" />}
                                    cellRenderer={(data) => (
                                    <Link onClick={() => store.ToolStore.setOpen(false)} className="link" to={`/app/main/${data.rowData.advisor.uid}`}>
                                        {data.rowData.advisor.name}
                                    </Link>
                                    )} />
                            ) : null}

                            <Column
                                width={100}
                                dataKey=""
                                headerRenderer={() => <ColumnHeaderAccount label="Sponsor" />}
                                cellRenderer={(data) => (
                                    <Link onClick={() => store.ToolStore.setOpen(false)} className="link" to={`/app/main/${data.rowData.sponsor.uid}`}>
                                        {data.rowData.sponsor.name}
                                    </Link>
                                )} />

                            <Column
                                width={90}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="enquiryUid" />}
                                cellRenderer={(data) => {
                                    if (!data.rowData.enquiryUid) return <span className="font-grey">Standalone</span>

                                    return (
                                        <Link onClick={() => store.ToolStore.setOpen(false)} className="link" to={`/app/main/${data.rowData.case.uid}/${data.rowData.enquiryUid}`}>
                                            {data.rowData.enquiryUid.replace("ENQUIRY_", "Assessment ")}
                                        </Link>
                                    )
                                }} />

                            <Column
                                width={210}
                                dataKey=""
                                headerRenderer={() => <ColumnHeader value="advisorEmail" />}
                                cellRenderer={(data) => <span>{data.rowData.advisorEmail}</span>} />
                        </Table>
                    )}
                </AutoSizer>

                {store.AutomationStore.loadingLog ? <LinearProgress color="secondary" style={{marginTop: `${rowHeight}px`}} /> : null}
            </div>
        </>
    )
})


const DateColumnHeader = observer(function () {

    const { minDate, maxDate, setMinDate, setMaxDate } = store.AutomationStore

    const [min, setMin] = React.useState<Date>(minDate)
    const [max, setMax] = React.useState<Date>(maxDate)

    const submit = () => {
        setMinDate(min)
        setMaxDate(max)
    }

    const Opener = () => {
        var label = "Show all"

        if (!isValid(min) && isValid(max)) {
            label = "All up to " + format(max, "yyyy-MM-dd")
        }
        
        if (isValid(min) && !isValid(max)) {
            label = "All after " + format(min, "yyyy-MM-dd")
        }

        if (isValid(min) && isValid(max)) {
            label = "Within " + formatDistance(max, min)
        }
        
        return <small className="link">{label}</small> 
    }

    const disabled = min === minDate && max === maxDate

    return (
        <InlineMenu opener={<div><Opener /></div>} closeOnClick={false}>
            <div style={{padding: "10px"}}>
                <Field.Date formik value={min} onChange={e => setMin(new UTCDate(e.target.value))} label="From date" />
                
                <Field.Date formik value={max} onChange={e => setMax(new UTCDate(e.target.value))} label="To date" />
                
                <div className="header">
                    <Button
                        color="success"
                        variant="contained"
                        className="btn btn-xs"
                        disabled={disabled}
                        onClick={() => submit()}>
                        Apply filter
                    </Button>
                </div>
            </div>
        </InlineMenu>
    )
})


function ColumnHeader ({value}) {

    var {order, orderedBy, setOrder, setOrderedBy} = store.ReportStore

    return (
        <div>
            <Button className="btn btn-lowercase" color="info" onClick={() => {
                if (orderedBy !== value) {
                    setOrderedBy(value)
                } else {
                    setOrder(order === "asc" ? "desc" : "asc")
                }
            }}>
                {DisplayValue("dict_key", value)}

                {orderedBy === value ? (
                    <>
                        {order === "asc" ? <Icons.ArrowUp style={{fontSize: "12px"}} /> : <Icons.ArrowDown style={{fontSize: "12px"}} />}
                    </>
                ) : null}
            </Button>
        </div>
    )
}